// extracted by mini-css-extract-plugin
export default {"tooltip-overlay":"styles_tooltip-overlay__2kn8S","icon-wrapper":"styles_icon-wrapper__5JEOa","icon":"styles_icon__o--qJ"};